import React, {useState, useEffect, useRef} from 'react';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';

import './AllForDanmuku.scss';

interface IAllForDanmuku {
  rootStore?:RootStore;
  enable:boolean;
}

const randomIndex = function(max: number) {
  return Math.floor(Math.random() * max);
};

const commentSize = [24, 36, 48, 56, 64];
// const commentColor = [0xffffff, 0x0000ff, 0xcc0000, 0xff66ff, 0xffff33];
const commentColor = [0xffffff, 0xd6cc39, 0xc50b1a, 0x0e8ed1, 0xffffff]

const Index = (props:IAllForDanmuku)=>{
  const { enable } = props;

  const {commentV2Store, imStore} = props.rootStore!;

  const wrapperRef = useRef<HTMLDivElement>(null)
  const [manager, setManager] = useState(null as any);
  const [waitList, setWaitList] = useState([] as any[]);

  useEffect(()=>{
    if(wrapperRef && wrapperRef.current) {
      let instance = new window.CommentManager(
        wrapperRef.current
      );
      instance.init('css');

      setManager(instance);
    }
  }, [wrapperRef]);
  
  
  const insert = (comment: any)=>{
    if (comment) {
      manager.send({
        // stime: this.video.currentTime + 1,
        size: commentSize[randomIndex(5)],
        color: commentColor[randomIndex(5)],
        ...comment
      });
    }
  };

  const onMessage = (e: any)=>{
    if (e) {
      let { type, content } = e;
      if (type && content) {
        let comment = {} as any;
        if (['text', 'question'].indexOf(type) > -1) {
          comment.mode = 1;
          comment.text = content;
        }

        if (comment.text || comment.code) {
          if (comment.text && comment.text.length > 20) {
            comment.dur = Math.max(
              5000,
              comment.text && comment.text.length
                ? Math.round((comment.text.length * 1000) / 5)
                : 0
            );
          } else {
            comment.dur = 5000 + randomIndex(3) * 1000;
          }
          insert(comment);
        }
      }
    }
  };

  const danmukuStart = ()=>{
    manager.start();

    imStore.addMessageListener('text', onMessage);
    imStore.addMessageListener('question', onMessage);
  };

  const danmukuStop = ()=>{
    manager.stop();
    manager.clear();

    imStore.removeMessageListener('text', onMessage);
    imStore.removeMessageListener('question', onMessage);
  };
  
  useEffect(()=>{
    if(manager) {
      if(enable) {
        danmukuStart();
      }else {
        danmukuStop();
      }
    }

    return ()=>{
      if(manager) {
        manager.stop();
      }
      imStore.removeMessageListener('text', onMessage);
      imStore.removeMessageListener('question', onMessage);
    }
  }, [manager, enable]);

  useEffect(()=>{
    const onUpdate = ()=>{
      manager.time(Date.now());
    };

    let timer = 0;
    if(manager) {
      if(enable) {
        timer = window.setInterval(onUpdate, 16);
      }
    }

    return ()=>{
      window.clearInterval(timer);
    }
  }, [manager, enable]);

  const fetchFullHistory = async ()=>{
    let temp = [] as any[];
    let historyTotal = 0;
    const fetchOne = async (useLast:boolean)=>{
      const res = await commentV2Store.getHistory(window.gallery.id, 'danmuku', useLast, false) as any;
      if(res && res.code == 200) {
        const {data} = res;
        const {items, total} = data;
        historyTotal = total;
        temp = temp.concat(items.map((it:any)=>{
          return {
            id:it.id,
            type:'text',
            content:it.content
          }
        }));
      }
    };

    await fetchOne(false);
    if(historyTotal > temp.length) {
      await fetchOne(true);
      if(historyTotal > temp.length) {
        await fetchOne(true);
      }
    }

    setWaitList(temp);
  }

  const [inited, setInited] = useState(false);

  useEffect(()=>{
    if(!inited && waitList && waitList.length == 0) {
      fetchFullHistory();
      setInited(true);
    }
  }, [waitList, inited]);

  useEffect(()=>{
    let timer = 0;
    if(waitList && waitList.length && enable) {
      let one = waitList[waitList.length - 1];
      onMessage(one);
      timer = window.setTimeout(()=>{
        setWaitList(waitList.slice(0, -1));
      }, (1 + randomIndex(3)) * 1000);
    }

    return ()=>{
      window.clearTimeout(timer);
    }
  }, [waitList, enable]);

  return <div className="all-for-danmuku" ref={wrapperRef}>

  </div>
};

export default inject("rootStore")(observer(Index));